export default "__VITE_ASSET__BUT$BjQA__"